/** Texto corto de ejemplo (genérico, sin marcas ni carta específica). */
export const CLIENT_ORDER_FORMAT_EXAMPLE = `2 producto sin ingrediente
1 bebida
María González
Av. Principal 123, Santiago
pago efectivo
+56 9 1234 5678`;

/** Mensaje que el local puede enviar al cliente para que mande el pedido ordenado. */
export const CLIENT_ORDER_REQUEST_MESSAGE = `Hola! Para tomar tu pedido más rápido, mándame la info así (una cosa por línea):

• Qué quieres (cantidad + producto)
• Tu nombre
• Dirección (si es delivery)
• Forma de pago
• Tu teléfono

Ejemplo:
${CLIENT_ORDER_FORMAT_EXAMPLE}`;
